<template>
  <div>
    <section class="content">
      <el-dialog title="Cargar un Nuevo Comprobante" :visible.sync="showModal" width="90%" :lock-scroll="false" max-width="500px">
        <p>Datos del Documento </p>
           <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>Tipo Documento</label>
            </div>
            <div>
                <el-select clearable placeholder="Tipo de documento"  v-model="nuevoDocumento.documentType">
                   <el-option  v-for="item in buyOrderDocumentType" :value="item.idBuyOrderDocumentType" :key="item.buyOrderDocumentType" :label="item.description"></el-option>
                 </el-select>
            </div>
          </div>

          <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>Código AFIP</label>
            </div>
            <div class="col-sm-9">
              <div>
                   <el-select v-model="nuevoDocumento.documentCode" :disabled="nuevoDocumento.documentType === ''" required  placeholder="Seleccionar ">
                    <el-option v-for="item in buyOrderDocumentTypeCode" :key="item.idBuyOrderDocumentTypeCode" :value="item.idBuyOrderDocumentTypeCode" :label="item.description"></el-option>
                  </el-select>
                 </div>
            </div>
          </div>
          <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>Letra</label>
            </div>
            <div class="col-sm-9">
                <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="buyOrder"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
            </div>
          </div>
          <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>Numero</label>
            </div>
            <div class="col-sm-9">
                <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="buyOrder"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
               <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="buyOrder"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
            </div>
          </div>
          <p>Datos CAE </p>
         <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>Fecha Vencimiento</label>
            </div>
            <div class="col-sm-9">
                <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="buyOrder"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
            </div>
          </div>
           <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>Nª</label>
            </div>
            <div class="col-sm-9">
                <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="buyOrder"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
            </div>
          </div>

          <div class="col-sm-12 entrada">
              <div class="col-sm-3">
                  <label>PDF (Obligatorio)</label>
              </div>
              <div class="col-sm-9">
                <input type="file" accept="application/pdf" ref="fileBuyOrder" class="form-control-file" style="width:80%; float: left;">
                <el-button type="primary" style="margin-left:6%;" circle icon="el-icon-upload">
                </el-button>
              </div>
          </div>

        <p>Datos de Referencia </p>
         <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>HES</label>
            </div>
            <div class="col-sm-9">
                <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="buyOrder"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
            </div>
          </div>
          <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>MIGO</label>
            </div>
            <div class="col-sm-9">
                <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="buyOrder"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
            </div>
          </div>
          <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>OC</label>
            </div>
            <div class="col-sm-9">
                <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="buyOrder"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
            </div>
          </div>
        <p>Importes</p>
         <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>Importe Total</label>
            </div>
            <div class="col-sm-9">
                <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="buyOrder"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
            </div>
          </div>
                   <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>Importe Impuesto</label>
            </div>
            <div class="col-sm-9">
                <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="buyOrder"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
            </div>
          </div>
                   <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>Porcentaje Impuesto</label>
            </div>
            <div class="col-sm-9">
                <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="buyOrder"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
            </div>
          </div>
                   <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>Moneda</label>
            </div>
            <div class="col-sm-9">
                <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="buyOrder"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
            </div>
          </div>
          <div class="col-sm-12 entrada">
            <div class="col-sm-3">
                <label>Tipo de Cambio</label>
            </div>
            <div class="col-sm-9">
                <el-input type="text" v-validate="'required'" required name="nombre" placeholder="Numero de OC" v-model="buyOrder"></el-input>
                <!-- <span>{{ errors.first('nombre') }}</span> -->
            </div>
          </div>
        <span slot="footer" class="dialog-footer">
            <button class="btn btn-primary" v-on:click="saveNIC()">
              Guardar
            </button>
            <button class="btn" v-on:click="showModal = false">
              Cancelar
            </button>
        </span>
    </el-dialog>
      <h3> Panel de control </h3>
      <div class="row" v-if="statusList">
        <div class="col-md-12 col-lg-12">
          <div class="box box-info">
            <div class="box-body">
              <table class="table table-striped">
                <thead>
                  <tr style="'font-size: 15px; text-align:center;">
                    <th :style="'text-align: center; vertical-align: middle;width: ' + (100 / statusList.length) + '%'" v-for="item in statusList" :key="item.idBuyOrderDocumentStatus">{{item.description}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="font-size: 25px; text-align:center" v-loading="loadingStatus">
                    <td  class="statusHover" v-for="item in statusList" :key="item.idBuyOrderDocumentStatus" v-on:click="searchStatus(item.idBuyOrderDocumentStatus)">{{statusCount[item.idBuyOrderDocumentStatus]}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center" v-if="response" >
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-yellow"><i class="ion ion-android-alert"></i></span>
                <div class="info-box-content">
                  <span class="info-box-text">Advertencia</span>
                  <span class="info-box-info">{{response}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>
      <div class="box-body">
        <h3> Filtros </h3>
        <div style="margin-bottom: 10px">
          <el-row>
            <el-col :xs="24" :sm="1" :md="2" style="margin-top: 8px" class="filter">
              <span class="input-label"> OC </span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="9">
              <el-input type="text" placeholder="OC" clearable @keyup.enter.native="filters[2].value = filtroNic" @clear="filters[2].value = filtroNic" @blur="filters[2].value = filtroNic" v-model="filtroNic">
              </el-input>
            </el-col>
            <el-col :xs="24" :sm="1" :md="1" style="margin-top: 8px" class="filter">
              <span class="input-label"> CUIT </span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="9">
              <el-input type="text" placeholder="CUIT" clearable @keyup.enter.native="filters[3].value = filtroCuit" @clear="filters[3].value = filtroCuit" @blur="filters[3].value = filtroCuit" v-model="filtroCuit">
              </el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="1" :md="2" class="filter" style="margin-top:5px">
              <span class="input-label"> Estado </span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="9">
              <el-select clearable placeholder="Estado" multiple v-model="filters[0].value" style="width:100%">
                <el-option
                  v-for="item in statusList"
                  :key="item.idBuyOrderDocumentStatus"
                  :value="item.idBuyOrderDocumentStatus"
                  :label="item.description">
                </el-option>
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="1" :md="1" class="filter" style="margin-top:8px">
              <span class="input-label"> Fecha </span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="9">
              <el-date-picker
              style="width:100%"
              v-model="filters[1].value"
              type="daterange"
              range-separator="A"
              start-placeholder="Desde"
              end-placeholder="Hasta"
              value-format="yyyy-MM-dd"
              unlink-panels>
              </el-date-picker>
            </el-col>
          </el-row>
        </div>

        <h3> Resultados </h3>
        <data-tables-server v-loading="loadingBuyOrderDocuments" :data="buyOrderDocuments" @query-change="getBuyOrderDocuments" :total="totalDocuments" class="table-responsive" :pagination-props="{ pageSizes: [10, 20, 30] }"  :filters="filters">
          <el-table-column label="OC">
            <template slot-scope="scope">
              {{scope.row.nic ? scope.row.nic : '-'}}
            </template>
          </el-table-column>
          <el-table-column label="CUIT" >
            <template slot-scope="scope">
              {{scope.row.cuit}}
            </template>
          </el-table-column>

          <el-table-column label="Tipo" >
            <template slot-scope="scope">
              {{getTypeName(scope.row.documentType)}}
            </template>
          </el-table-column>
          <el-table-column label="Importe Total" >
            <template slot-scope="scope">
              {{ `${scope.row.moneda}$ ${scope.row.importeTotal}`}}
            </template>
          </el-table-column>
          <el-table-column label="Enviada" >
            <template slot-scope="scope">
              {{scope.row.date}}
            </template>
          </el-table-column>
          <el-table-column label="Estado">
            <template slot-scope="scope">
              {{ getStatusName(scope.row.idBuyOrderDocumentStatus) }}
            </template>
          </el-table-column>
          <!--<el-table-column label="Hes" >
            <template slot-scope="scope">
              <ul v-for="hes in scope.row.hes" :key="hes.idHes">
                {{hes.number}}
              </ul>
            </template>
          </el-table-column>-->
          <el-table-column label="Info. Rechazo" v-if="user.isProvider" >
            <template slot-scope="scope">
              <el-button :disabled="!scope.row.mensajeRechazo" icon="el-icon-info" type="primary" circle @click="mostrarMensajeCompleto(scope.row.idMensajeRechazo)" :title="scope.row.mensajeRechazo ? 'Ver mensaje de rechazo' : 'No existe mensaje de rechazo'"></el-button>
            </template>
          </el-table-column>
          <el-table-column label="Archivo">
            <template slot-scope="scope">
              <a v-if="scope.row.pdf !== '0'" :href="'upload/' + scope.row.pdf" target="_blank" style="padding-right: 20px">
                <i class="fa fa-file-pdf-o"/> PDF
              </a>
            </template>
          </el-table-column>
          <!--<el-table-column label="Comentario" >
            <template slot-scope="scope">
              <el-button icon="el-icon-info" type="primary" circle @click="mostrarMensajeCompleto(scope.row.documentComment)"></el-button>
            </template>
          </el-table-column>-->
          <el-table-column label = "Acciones">
            <template slot-scope="scope" >
              <el-tooltip class="item" effect="dark" content="Ver operación" placement="top">
                  <el-button type="primary" icon="el-icon-view" circle @click="goToDetails(scope.row.idBuyOrderDocument)"></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" v-if="(!user.isProvider && scope.row.idBuyOrderDocumentStatus === '2') || scope.row.idBuyOrderDocumentStatus === '4'" content="Orden de Pago" placement="top">
                <el-button  v-if="(scope.row.documentType === '1' || scope.row.documentType ==='3')" :type="scope.row.idBuyOrderDocumentStatus === '2'? 'primary' : 'success'" icon="far fa-file-alt" circle @click="openModalPaymentOrder(scope.row)"></el-button>
              </el-tooltip>
              <el-button v-if="scope.row.idBuyOrderDocumentStatus === '3' && !user.isProvider" icon="el-icon-info" type="primary" circle @click="mostrarMensajeCompleto(scope.row.idMensajeRechazo)"></el-button>
            </template>
          </el-table-column>
          <el-table-column label="Guardar" align="center" v-if="!user.isProvider">
            <template slot="header">
                Administrar Facturas
            </template>
            <template slot-scope="scope" v-if="scope.row.idBuyOrderDocumentStatus === '1'">
              <el-button-group>
                <el-tooltip class="item" effect="dark" content="Aprobar" placement="bottom-end" >

                <el-button icon="el-icon-success" size="big" :type="(documentosAceptados.includes(scope.row)) ? 'primary' : ''" @click="modalAprobar(scope.row)">
                </el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Rechazar" placement="bottom-end">
                <el-button icon="el-icon-error"  size="big" :type="(documentosRechazados.includes(scope.row)) ? 'primary' : ''" @click="openRechazarDialog(scope)">
                </el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </data-tables-server>
      </div>
      <!--Modal de aprobar factura-->

      <el-dialog :visible.sync="showModalAprobar" title="Confirmar acción" center>
        <div style="display:flex; flex-direction: column; justify-content: center; align-items: center;">
          <div>
            <p style="font-size: 16px;"> ¿Está seguro que desea aprobar esta factura? </p>
              <div style="margin-top:2rem; display:flex; justify-content: center;">
                <el-button class="btn" type="success" v-on:click="AproveDocument">
                  Confirmar
                </el-button>
                <el-button class="btn" type="danger" v-on:click="() => showModalAprobar = false">
                  Cancelar
                </el-button>                                    
              </div>
            </div>
          </div>
        </el-dialog>

      <!--Modal de rechazar factura-->

      <el-dialog :visible.sync="showModalRechazar" title="Confirmar acción" center>
        <div style="display:flex; flex-direction: column; justify-content: center; align-items: center;">
          <div>
            <p style="font-size: 16px;"> Seleccione el motivo por el que desea rechazar la factura </p>
                    <el-select v-model="nuevoDocumento.mensajeRechazo" placeholder="Motivo de rechazo">
                    <el-option
                        v-for="item in rejectReasons"
                        :key="item.idMensajeRechazo"
                        :label="item.description"
                        :value="item.idMensajeRechazo">
                    </el-option>
                </el-select>
              <div style="margin-top:2rem; display:flex; justify-content: center;">
                <el-button class="btn" type="success" v-on:click="rejectDocument">
                  Confirmar
                </el-button>
                <el-button class="btn" type="danger" v-on:click="() => showModalRechazar = false">
                  Cancelar
                </el-button>                                    
              </div>
            </div>
          </div>
        </el-dialog>

      <!-- MODAL CONFIRMAR DOCUMENTACION -->

                <el-dialog title="Confirmar cambios" style="margin-top: -10vh; overflow: hidden" :visible.sync="showModalConfirmarDocumentacion" max-width="700px" width="80%" v-on:close="cerrarModalConfirmarDocumentacion()">
                  <el-tabs type="card">
                    <el-tab-pane :label="'Documentos aceptados (' + documentosAceptados.length + ')'">
                      <el-table :data="documentosAceptados">
                        <el-table-column label="Tipo">
                          <template slot-scope="scope">
                            {{ getTypeName(scope.row.documentType) }}
                          </template>
                        </el-table-column>
                        <el-table-column property="date" label="Fecha"></el-table-column>
                        <el-table-column label="Archivo">
                          <template slot-scope="scope">
                            <a :href="'upload/' + scope.row.pdf" target="_blank" style="padding-right: 20px">
                              <i class="fa fa-file-pdf-o"/> PDF
                            </a>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="'Documentos rechazados (' + documentosRechazados.length + ')'">
                      <el-table :data="documentosRechazados" style="">
                        <el-table-column label="Tipo" width="130px">
                          <template slot-scope="scope">
                            {{ getTypeName(scope.row.documentType) }}
                          </template>
                        </el-table-column>
                        <el-table-column property="date" label="Fecha" width="200px"></el-table-column>
                        <el-table-column label="Archivo" width="90px">
                          <template slot-scope="scope">
                            <a :href="'upload/' + scope.row.pdf" target="_blank" style="padding-right: 20px">
                              <i class="fa fa-file-pdf-o"/> PDF
                            </a>
                          </template>
                        </el-table-column>
                        <el-table-column label="Mensaje" :span="12">
                          <template slot-scope="scope">
                            <el-select v-model="scope.row.mensajeRechazo" placeholder="Seleccione un motivo">
                              <el-option
                                v-for="reason in rejectReasons"
                                :key="reason.value"
                                :label="reason.value"
                                :value="reason.value">
                              </el-option>
                            </el-select>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-tab-pane>
                  </el-tabs>

                  <span slot="footer" class="dialog-footer">
                    <button class="btn" v-on:click="cerrarModalConfirmarDocumentacion()">
                      Cancelar
                    </button>
                    <button class="btn btn-primary" v-on:click="confirmarDocumentos()">
                      Guardar
                    </button>
                  </span>
                </el-dialog>


      <!-- MODAL AGREGAR ORDEN DE PAGO -->

                <el-dialog :title="'Orden de pago'" style="margin-top: -10vh; overflow: hidden"  v-if="buyOrderDocument" :visible.sync="showModalPaymentOrder" width="70%" :lock-scroll="false" v-on:close="resetNewPaymentOrder()" max-width="500px">
                  <div class="col-sm-12 entrada">
                    <div class="col-sm-4">
                      <label style="margin-top: -10px;">Orden de Pago / Retenciones</label>
                    </div>
                    <div class="col-sm-8">
                      <td v-if="buyOrderDocument.paymentOrder && buyOrderDocument.paymentOrder.pdf">
                        <span v-if="buyOrderDocument.paymentOrder.pdf === '0'">No se cargo un archivo</span>
                        <a  v-if="buyOrderDocument.paymentOrder.pdf !== '0'" :href="buyOrderDocument.paymentOrder.pdf" target="_blank"><i class="	fa fa-file-pdf-o"/>  Ver</a>
                      </td>
                      <span v-if="!user.isProvider && (!buyOrderDocument.paymentOrder || !buyOrderDocument.paymentOrder.pdf)">
                        <input type="file" accept="application/pdf" ref="filePayment" class="form-control-file" style="width:80%; float: left;">
                      </span>
                    </div>
                  </div>
                  <br><br><br>
                  <div class="col-sm-12 entrada">
                    <div class="col-sm-4">
                      <label style="margin-top: -10px;">Información de Pago</label>
                    </div>
                    <div class="col-sm-8">
                      <td>
                        <span v-if="buyOrderDocument.idBuyOrderDocumentStatus === '4' && buyOrderDocument.paymentOrder" v-html="buyOrderDocument.paymentOrder.comment"></span>
                      </td>
                      <span v-if="buyOrderDocument.idBuyOrderDocumentStatus === '2' && !user.isProvider && !buyOrderDocument.paymentOrder">
                        <vue-editor v-model="newPaymentOrder.comment"></vue-editor>
                      </span>
                    </div>
                  </div>


                  <span slot="footer" class="dialog-footer">
                    <button v-if="!buyOrderDocument.paymentOrder" class="btn" v-on:click="hideModalPaymentOrder()">
                      Cancelar
                    </button>
                    <button v-if="!buyOrderDocument.paymentOrder" class="btn btn-primary" v-on:click="uploadPayment()">
                      Guardar
                    </button>
                    <button  v-if="buyOrderDocument.paymentOrder" class="btn btn-primary" v-on:click="hideModalPaymentOrder()">
                      Aceptar
                    </button>
                  </span>
                </el-dialog>
    </section>
  </div>
</template>
<script>
  require('moment')
  // Require needed datatables modules
  import datepicker from 'vue-date-picker'
  import api from '../../api'
  import MaskedInput from 'vue-text-mask'
  import { mapState } from 'vuex'
  import { VueEditor } from 'vue2-editor'
  import UploadReceipt from './UploadReceipt.vue'
  import apiHelper from '../helpers/apiHelper'

  export default {
    name: 'Search',
    components: {
      datepicker,
      MaskedInput,
      VueEditor,
      'upload-receipt': UploadReceipt
    },
    data (router) {
      return {
        buyOrder: '',
        showModalAprobar: false,
        showModalRechazar: false,
        queryBackup: null,
        statusCount: [],
        selectedScope: null,
        filtroNic: '',
        filtroCuit: '',
        totalDocuments: 0,
        currentApiCalls: 0,
        loadingBuyOrderDocuments: false,
        loadingStatus: false,
        currentApiStatusCalls: 0,
        buyOrderDocuments: [],
        section: 'Search',
        loading: '',
        tipoFecha: 'emision',
        estado: '',
        response: '',
        desde: '',
        hasta: '',
        cliente: '',
        referencia: '',
        codes: [],
        fecha: '',
        facturas: this.$store.state.facturas,
        providers: null,
        nuevoDocumento: {
          idBuyOrder: '',
          pdf: '',
          documentType: '',
          documentCode: '',
          letra: '',
          numero: '',
          fechaVencimiento: '',
          cae: '',
          oc: '',
          hes: '',
          migo: '',
          total: '',
          impuesto: '',
          porcentajeImpuesto: '',
          moneda: '',
          tipoCambio: '',
          visto: 0,
          idBuyOrderDocumentStatus: 1,
          mensajeRechazo: '',
          documentComment: ''
        },
        clients: [],
        buyOrderDocument: '',
        newPaymentOrder: {
          pdf: '',
          comment: ''
        },
        showModalPaymentOrder: false,
        showModalConfirmarDocumentacion: false,
        showModal: false,
        confirmPayment: false,
        documentosAceptados: [],
        documentosRechazados: [],
        nuevoMensajeRechazo: '',
        rejectReasons: '',
        receptor: '',
        idUser: this.$store.state.user.idUser,
        filtrados: [],
        table: '',
        vue: this,
        rutMask: this.$store.state.rutMask,
        invoiceMask: this.$store.state.invoiceMask,
        filters: [{
          prop: 'idBuyOrderDocumentStatus',
          value: '',
          type: 'multiSelect'
        },
        {
          prop: ['date'],
          value: '',
          type: 'dateRange'
        },
        {
          prop: 'nic',
          value: ''
        },
        {
          prop: 'FiscalId',
          value: ''
        }]
      }
    },
    computed: {
      ...mapState([
        'user'
      ]),
      statusList () {
        let status = this.$store.state.buyOrderDocumentStatus
        return status
      },
      buyOrderDocumentType () {
        return this.$store.state.buyOrderDocumentType
      },
      buyOrderDocumentTypeCode () {
        return this.$store.state.buyOrderDocumentTypeCode
      },
      typeList () {
        let types = this.$store.state.buyOrderDocumentType
        return types
      }
    },
    methods: {
      getTotalBuyOrderDocument (queryInfo = '') {
        let substringPosition = queryInfo.search('condition=')
        let query = queryInfo.substring(substringPosition + 10)
        if (this.user.isProvider) {
          apiHelper.getTotal('buyOrderDocument', query + ' AND buyOrder.idCompany =' + this.user.company.idCompany)
          .then(count => {
            this.totalDocuments = count
          })
        } else {
          apiHelper.getTotal('buyOrderDocument', query)
          .then(count => {
            this.totalDocuments = count
          })
        }
      },
      openRechazarDialog (scope) {
        this.showModalRechazar = true
        this.selectedScope = scope
      },
      rejectDocument () {
        const id = this.selectedScope.row.idBuyOrderDocument
        const apiUrl = `api/RejectDocument?id=${id}&idMessage=${this.nuevoDocumento.mensajeRechazo}`
        api.request('GET', apiUrl)
          .then(response => {
            this.$message.success('El estado de la factura ha sido actualizado', 'success')
            window.location.reload()
          })
          .catch(error => {
            this.$message.error(error.response.data, 'error')
          })
      },
      modalAprobar (buyOrderDocument) {
        this.$confirm(
        '¿Está seguro que desea aprobar esta factura?',
        'Atención',
          {
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            type: 'warning'
          }
        ).then(() => {
          this.AproveDocument(buyOrderDocument.idBuyOrderDocument)
        })
      },
      getCountByStatus () {
        for (let index = 1; index <= 4; index++) {
          this.startLoadingStatus()
          if (this.user.isProvider) {
            apiHelper.getTotal('buyOrderDocument', 'idBuyOrderDocumentStatus = ' + index + ' AND buyOrder.idCompany =' + this.user.company.idCompany)
            .then(count => {
              this.statusCount[index] = count
              this.stopLoadingStatus()
            })
          } else {
            apiHelper.getTotal('buyOrderDocument', 'idBuyOrderDocumentStatus = ' + index)
            .then(count => {
              this.statusCount[index] = count
              this.stopLoadingStatus()
            })
          }
        }
      },
      startLoadingStatus () {
        this.currentApiStatusCalls++
        this.loadingStatus = true
      },
      stopLoadingStatus () {
        this.currentApiStatusCalls--
        if (this.currentApiStatusCalls === 0) this.loadingStatus = false
      },
      startLoading () {
        this.currentApiCalls++
        this.loadingBuyOrderDocuments = true
      },
      stopLoading () {
        this.currentApiCalls--
        if (this.currentApiCalls === 0) this.loadingBuyOrderDocuments = false
      },
      getBuyOrderDocuments (queryInfo = '') {
        this.queryBackup = queryInfo
        let query = apiHelper.getQueryForApi(queryInfo)
        this.getTotalBuyOrderDocument(query)
        this.startLoading()
        api.request('GET', 'api/getBuyOrderDocument/' + this.user.idUser + query)
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            if (this.user.isProvider) {
              data = data.filter(el => el.idCompany === this.user.company.idCompany)
            }
            this.buyOrderDocuments = data
          }
          this.stopLoading()
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
          this.loadingBuyOrderDocuments = false
        })
      },
      getRejectionMessages () {
        api.request('GET', `api/getRejectionMessages`)
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.rejectReasons = data.data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
      },
      getBuyOrderDocumentDetails () {
        api.request('GET', 'api/getBuyOrderDocumentDetails/')
        .then((res) => console.log(res.data))
        .catch((err) => console.log(err))
      },
      openModalPaymentOrder (buyOrderDocument) {
        this.showModalPaymentOrder = true
        this.buyOrderDocument = buyOrderDocument
      },
      AproveDocument (id) {
        const apiUrl = `api/AproveDocument?id=${id}`
        api.request('GET', apiUrl)
          .then(response => {
            this.$message.success('El estado de la factura ha sido actualizado', 'success')
            window.location.reload()
          })
          .catch(error => {
            this.$message.error(error.response.data, 'error')
          })
      },
      uploadPayment () {
        if (this.newPaymentOrder.comment === null) {
          this.$alert('Para confirmar la operación debe detallar la información de Pago', 'Advertencia', {
            confirmButtonText: 'Aceptar',
            type: 'warning',
            lockScroll: false
          })
        } else {
          this.$confirm('¿Realmente desea adjuntar el comprobante?', 'Advertencia', {
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            type: 'warning',
            lockScroll: false
          })
                .then(() => {
                  let formData = new FormData()
                  formData.append('file', this.$refs.filePayment.files[0])
                  formData.append('folder', 'payments')
                  api.request('POST', 'api/uploadFile', formData)
                        .then(response => {
                          api.request('POST', 'api/generic/paymentOrder', JSON.stringify({
                            'pdf': response.data,
                            'comment': this.newPaymentOrder.comment
                          }))
                          .then(response2 => {
                            this.buyOrderDocument.idBuyOrderDocumentStatus = '4'
                            this.buyOrderDocument.idPaymentOrder = response2.data.idPaymentOrder
                            console.log(this.buyOrderDocument)
                            api.request('POST', 'api/generic/buyOrderDocument/' + this.buyOrderDocument.idBuyOrderDocument, JSON.stringify(this.buyOrderDocument))
                            .then(response3 => {
                              api.request('GET', 'api/sendMailBuyOrderDocumentStatus/' + this.buyOrderDocument.idBuyOrderDocument)
                              this.hideModalPaymentOrder()
                              this.getBuyOrderDocuments(this.queryBackup)
                            })
                          })
                        })
                })
                .catch(() => {
                })
        }
      },
      resetNewPaymentOrder () {
        this.newPaymentOrder = {
          pdf: '',
          comment: ''
        }
        this.buyOrderDocument = ''
      },
      hideModalPaymentOrder () {
        this.showModalPaymentOrder = false
        this.resetNewPaymentOrder()
      },
      handleIncluirDocumento (row, idBuyOrderDocumentStatus) {
        if (idBuyOrderDocumentStatus === 2) {
          if (!this.documentosAceptados.includes(row)) {
            this.documentosRechazados = this.documentosRechazados.filter(el => el !== row)
            this.documentosAceptados.push(row)
          } else {
            this.documentosAceptados = this.documentosAceptados.filter(el => el !== row)
          }
        }
        if (idBuyOrderDocumentStatus === 3) {
          if (!this.documentosRechazados.includes(row)) {
            this.documentosAceptados = this.documentosAceptados.filter(el => el !== row)
            this.documentosRechazados.push(row)
          } else {
            this.documentosRechazados = this.documentosRechazados.filter(el => el !== row)
          }
        }
      },
      cerrarModalConfirmarDocumentacion () {
        this.showModalConfirmarDocumentacion = false
        this.documentosRechazados.forEach(el => {
          el.mensajeRechazo = ''
        })
      },
      abrirModalConfirmacion () {
        this.showModalConfirmarDocumentacion = true
      },
      confirmarDocumentos () {
        var cantidadMensajesRechazados = this.documentosRechazados.filter(document => document['mensajeRechazo'] === null || document['mensajeRechazo'] === '').length
        var mensajeAlert = 'Debe completar los campos "Mensaje"'
        if (cantidadMensajesRechazados === 0) {
          this.cambiarEstadoDocumentos(this.documentosRechazados, 3)
          this.cambiarEstadoDocumentos(this.documentosAceptados, 2)
          this.documentosAceptados = []
          this.documentosRechazados = []
          this.cerrarModalConfirmarDocumentacion()
        } else {
          if (cantidadMensajesRechazados === 1) {
            mensajeAlert = 'Debe completar el campo "Mensaje"'
          }
          this.$message({
            type: 'warning',
            message: mensajeAlert
          })
        }
      },
      cambiarEstadoDocumentos (documentos, idBuyOrderDocumentStatus) {
        documentos.forEach(doc => {
          this.cambiarEstadoDocumento(doc, idBuyOrderDocumentStatus)
        })
      },
      cambiarEstadoDocumento (documento, estado) {
        documento.idBuyOrderDocumentStatus = estado.toString()
        api.request('POST', 'api/generic/buyOrderDocument/' + documento.idBuyOrderDocument, JSON.stringify(documento))
        .then(response => {
          if (estado === 3) {
            api.request('GET', 'api/sendMailBuyOrderDocumentStatus/' + documento.idBuyOrderDocument)
          }
        })
      },
      mostrarMensajeCompleto (idMensaje) {
        let mensajeDescription = this.rejectReasons.find((mensaje) => mensaje.idMensajeRechazo === idMensaje)
        this.$alert(mensajeDescription.description, 'Motivo de rechazo', {
          confirmButtonText: 'OK'
        })
      },
      searchStatus (status) {
        this.filters[0].value = [status]
        // this.filterInvoices()
      },
      getTypeName (idBuyOrderDocumentType) {
        if (this.typeList.length > 0) {
          return this.typeList.find(el => el.idBuyOrderDocumentType === idBuyOrderDocumentType).description
        } else {
          return '-'
        }
      },
      getStatusName (idBuyOrderDocumentStatus) {
        if (this.statusList.length > 0) {
          return this.statusList.find(el => el.idBuyOrderDocumentStatus === idBuyOrderDocumentStatus).description
        } else {
          return '-'
        }
      },
      goToDetails (idBuyOrder) {
        this.$router.push('/bill/' + idBuyOrder)
      },
      toggleLoading () {
        this.loading = (this.loading === '') ? 'cargando' : ''
      },
      resetResponse () {
        this.response = ''
      },
      compareViewNics (a, b) {
        if (a.view < b.view) {
          return -1
        } else if (a.view > b.view) {
          return 1
        }
        /* else if (a.payment && b.payment && a.payment.visto < b.payment.visto) {
          return -1
        } else if (a.payment && b.payment && a.payment.visto > b.payment.visto) {
          return 1
        } */
        return 0
      },
      compareViewInvoice (a, b) {
        if (!a.factura) {
          return 1
        }
        if (!b.factura) {
          return -1
        }
        if (a.factura.visto < b.factura.visto) {
          return -1
        } else if (a.factura.visto > b.factura.visto) {
          return 1
        }
        return 0
      }
    },
    beforeMount () {
      this.getCountByStatus()
      this.getRejectionMessages()
    }
  }
</script>
<style>
  @media (min-width: 767px) {
    .filter {
      text-align: center;
    }
  }
  .datetime-picker input {
    height: 4em !important;
  }

  /* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte. */

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
table.dataTable tr {
  cursor: pointer
}
.table {
  width: 100% !important;
}
.dataTables_length label, .dataTables_filter label{
  margin-bottom: 30px;
  position:static;
  display:block;
  pointer-events: fill;
  z-index:3000;
}
.statusHover:hover {
  transition: background-color 0.5s ease;
  cursor: pointer;
  background-color:darkgray;
  color:black;
}

.filtro {
  margin-bottom: 10px;
}
.sorting::after, .sorting_asc:after, .sorting_desc:after {
  margin-left: 5px;
}

.input-label {
    display: inline-block;
    padding: 2px 10px;
  }
</style>



// WEBPACK FOOTER //
// BillsManagement.vue?282dba99